const TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYXBwX2NvdW50cnlfcHJvZmlsZXMifQ.-NQLMpQoxk3Akq3_t061fNj_0Fiy5vH0IkhuwRVzoJM";

const year = 2023;

const URL = `https://api.data.taxjustice.net/latest/query/country_profiles?token=${TOKEN}&filter=year_sotj%20%3D%20${year}`;

export async function getProfilesData() {
  const res = await fetch(URL);
  return res.json();
}
